import React from 'react';
import Container from '../common/container';
import Image from 'next/image';
import { ArrowIcon } from '~/svgs/home-page';
import { NextLink, Translate } from '~/i18n';

const Features = () => {
   return (
      <section className="w-full h-full py-8">
         <Container>
            <div className="grid items-center w-full grid-cols-1 gap-8 lg:grid-cols-3">
               <NextLink
                  href="/madinah/destinations"
                  className="relative flex flex-col w-full h-full p-6 bg-black lg:col-span-2 lg:p-8 opacity-90 rounded-2xl">
                  <div className="flex items-end w-full gap-4">
                     <div className="w-full lg:w-4/5">
                        <div className="text-xl text-white ">
                           <Translate id="common:features" />
                        </div>
                        <div className="mb-4 text-4xl leading-relaxed text-white">
                           <Translate id="common:virtual guide" />
                        </div>
                        <Image
                           src="/madinah/home/feature-01-icon.svg"
                           width={36}
                           height={36}
                           alt="Virtual guide"
                        />

                        <div className="py-6 text-2xl font-light leading-none text-white opacity-70 lg:max-w-[70%]">
                           <Translate id="common:virtual guide subtitle" />
                        </div>

                        <div className="transition-all cursor-pointer hover:opacity-20">
                           <ArrowIcon className="rtl:rotate-180" />
                        </div>
                     </div>
                     <div className="items-end justify-end hidden w-full h-full lg:flex absolute bottom-0 ltr:right-8 rtl:left-8">
                        <Image
                           src="/madinah/home/feature-1.png"
                           width={204}
                           height={256}
                           alt="Virtual guide"
                           className="relative"
                        />
                     </div>
                  </div>
               </NextLink>
               <NextLink
                  href="/madinah/destinations"
                  className="relative flex flex-col w-full h-full p-6 bg-black lg:p-8 opacity-90 rounded-2xl bg-[url('/madinah/home/feature-2.png')] bg-no-repeat ltr:bg-right-bottom rtl:bg-left-bottom">
                  <div className="flex items-end w-full gap-4">
                     <div className="w-full">
                        <div className="text-xl text-white ">
                           <Translate id="common:features" />
                        </div>
                        <div className="mb-4 text-4xl leading-relaxed text-white">
                           <Translate id="common:madina 360" />
                        </div>
                        <Image
                           src="/madinah/home/feature-02-icon.svg"
                           width={65}
                           height={27}
                           alt="Madina 360"
                        />

                        <div className="py-6 text-2xl font-light leading-none text-white opacity-70">
                           <Translate id="common:madina 360 subtitle" />{' '}
                        </div>

                        <div className="transition-all cursor-pointer hover:opacity-20">
                           <ArrowIcon className="rtl:rotate-180" />
                        </div>
                     </div>
                  </div>
               </NextLink>
            </div>
         </Container>
      </section>
   );
};

export default Features;
